import { pickPreferredImageMedia } from "../media/media-selector.ts";
import type { ProviderType } from "../organizations/provider-type.ts";

type ListingProvider = {
    type?: ProviderType;
    name?: string;
    isVerified?: boolean;
};

export type ListingContactPreview = {
    provider?: ListingProvider;
    breedNames?: string[];
    imageUrl?: string;
};

export function listingContactPreview(
    listing: {
        primaryPhotoId: string | null;
        media: Array<{
            id: string;
            url: string | null;
            mimeType?: string | null;
        }>;
        listingBreedNames: string[];
        breeds: Array<{ name: string }>;
    },
    provider: ListingProvider,
): ListingContactPreview {
    const breedNames =
        listing.listingBreedNames.length > 0
            ? listing.listingBreedNames
            : listing.breeds.map((breed) => breed.name);
    return {
        provider,
        breedNames,
        imageUrl:
            pickPreferredImageMedia(
                listing.media.filter((item) => item.url),
                listing.primaryPhotoId,
            )?.url ?? undefined,
    };
}

export function listingContactPreviewFromSearchItem(
    item: { imageUrls: string[]; breeds: Array<{ name: string }> },
    provider: ListingProvider,
): ListingContactPreview {
    return {
        provider,
        breedNames: item.breeds.map((breed) => breed.name),
        imageUrl: item.imageUrls[0],
    };
}
